'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollToTop(e) {
  e.preventDefault();
  setTimeout(function () {
    var moveTo = new _moveto2.default();
    moveTo.move(document.getElementsByTagName('body')[0]);
  }, 100);
}

var ScrollToTop = function (_React$Component) {
  (0, _inherits3.default)(ScrollToTop, _React$Component);

  function ScrollToTop(props) {
    (0, _classCallCheck3.default)(this, ScrollToTop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollToTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollToTop)).call(this, props));

    _this.state = {
      visible: false
    };

    _this.lastChecked = 0;
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ScrollToTop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (this.lastChecked < Date.now() - 100) {
        var scrollPosition = window.scrollY || window.pageYOffset;
        this.lastChecked = Date.now();
        if (scrollPosition > 200) {
          this.setState({
            visible: true
          });
        } else if (scrollPosition < 200) {
          this.setState({
            visible: false
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var visible = this.state.visible;


      if (!visible) {
        return null;
      }

      return _react2.default.createElement(
        'a',
        (0, _assign2.default)({ href: '', onClick: scrollToTop }, this.props),
        children
      );
    }
  }]);
  return ScrollToTop;
}(_react2.default.Component);

ScrollToTop.propTypes = {
  children: _propTypes2.default.node
};
ScrollToTop.defaultProps = {
  children: 'To Top'
};

exports.default = ScrollToTop;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ScrollToTop.js
// module id = 1151
// module chunks = 0